import { LicenseInfo } from '@mui/x-license';

interface ClientConfig {
  muiLicenseKey?: string;
}

let configPromise: Promise<ClientConfig> | null = null;

/**
 * Fetches client configuration from the server.
 * The result is cached for subsequent calls.
 */
export async function fetchClientConfig(): Promise<ClientConfig> {
  if (!configPromise) {
    configPromise = fetch('/api/client-config')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch client config: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.warn('Failed to load client config:', err);
        return {};
      });
  }
  return configPromise;
}

/**
 * Initializes client-side configuration including MUI license.
 * Call this before rendering the app.
 */
export async function initializeClientConfig(): Promise<void> {
  const config = await fetchClientConfig();

  if (config.muiLicenseKey) {
    LicenseInfo.setLicenseKey(config.muiLicenseKey);
  }
}
